/** Shopify CDN: Minification failed

Line 37:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 38:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 28:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 29:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 60:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 19:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 20:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 10:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 11:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 42:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    theme.config.mqlSmall && !this.summaryIsEmpty && this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('footer-accordion', FooterAccordion);